import { useCallback, useEffect, useRef, useState } from 'react';

export const useIntersection = () => {
  const [currentIndex, setCurrentIndex] = useState<number>();
  const intersectionsRef = useRef<number[]>([]);
  const timeoutRef = useRef<number>();

  const handleIntersectionChange = useCallback(
    (entry: IntersectionObserverEntry, index: number) => {
      intersectionsRef.current[index] = entry.intersectionRatio;

      window.clearTimeout(timeoutRef.current);

      timeoutRef.current = window.setTimeout(() => {
        const currentEntry = intersectionsRef.current
          .map((intersectionRatio, index) => {
            return {
              intersectionRatio,
              index,
            };
          })
          .reduce((prev, curr, index) => {
            const isCurrentEntry =
              index === intersectionsRef.current.length - 1
                ? curr.intersectionRatio >= prev.intersectionRatio
                : curr.intersectionRatio > prev.intersectionRatio;

            return isCurrentEntry ? curr : prev;
          });

        setCurrentIndex(currentEntry.index);
      }, 500);
    },
    []
  );

  useEffect(() => {
    return () => window.clearTimeout(timeoutRef.current);
  }, []);

  return {
    currentIndex,
    handleIntersectionChange,
  };
};
